<div class="desktop">
  <a [link]="orderLink()" mat-icon-button matTooltip="Bestellung ansehen" matTooltipPosition="above" uiLink>
    <ui-icon faName="eye" faStyle="light"></ui-icon>
  </a>
  @if (canReorder()) {
    <ui-icon-button
      (clicked)="addToCartClicked()"
      [loading]="isAddToCartLoading()"
      [tooltip]="'Nachbestellen ('+ order().items.length + ' Positionen)'"
      buttonStyle="unthemed"
      icon="cart-shopping"
      iconStyle="light"
      tooltipPosition="above"
    ></ui-icon-button>
  }
  @if (canUseSrm()) {
    <ui-icon-button
      (clicked)="onOpenSrmForm()"
      tooltip="Bestellung beanstanden oder zurücksenden"
      buttonStyle="unthemed"
      icon="share"
      iconStyle="light"
      tooltipPosition="above"
    ></ui-icon-button>
  }
  <ng-container *uiPriceVisibility>
    <ui-icon-button
      (clicked)="onOpenDocuments()"
      matTooltip="Rechnungen und Lieferscheine"
      buttonStyle="unthemed"
      icon="file-lines"
      iconStyle="light"
      matTooltipPosition="above"
    ></ui-icon-button>
  </ng-container>
  <a [href]="deliveryTrackingLink()" mat-icon-button matTooltip="Lieferstatus nachverfolgen" matTooltipPosition="above" target="_blank">
    <ui-icon faName="truck-fast" faStyle="light"></ui-icon>
  </a>
</div>
<div class="mobile">
  <a [link]="orderLink()" mat-button uiLink>
    <ui-icon faName="eye" faStyle="light"></ui-icon>
    Bestellung ansehen
  </a>
  @if (canReorder()) {
    <ui-button
      (clicked)="addToCartClicked()"
      [loading]="isAddToCartLoading()"
      [tooltip]="'Nachbestellen ('+ order().items.length + ' Positionen)'"
      buttonStyle="text"
      icon="cart-shopping"
      iconStyle="light"
    >
      Nachbestellen ({{ order().items.length }} Positionen)
    </ui-button>
  }
  @if (canUseSrm()) {
    <ui-button
      (clicked)="onOpenSrmForm()"
      tooltip="Bestellung beanstanden oder zurücksenden"
      buttonStyle="text"
      icon="share"
      iconStyle="light"
    >
      Bestellung beanstanden oder zurücksenden
    </ui-button>
  }
  <ng-container *uiPriceVisibility>
    <ui-button
      (clicked)="onOpenDocuments()"
      buttonStyle="text"
      icon="file-lines"
      iconStyle="light"
    >
      Rechnungen und Lieferscheine
    </ui-button>
  </ng-container>
  <a [href]="deliveryTrackingLink()" mat-button target="_blank">
    <ui-icon faName="truck-fast" faStyle="light"></ui-icon>
    Lieferung verfolgen
  </a>
</div>
